
import React, { useState } from 'react';
import './FilesPage.css';
import PageHeader from '../../components/shared/PageHeader';
import Button from '../../components/shared/Button';
import Badge from '../../components/shared/Badge';
import { useToast } from '../../context/ToastContext';

const DRIVES = [
  { id: 'local', label: 'Local Storage', icon: '💾', used: 73, total: '1 TB', color: 'var(--color-warning)' },
  { id: 'cloud', label: 'Cloud Drive', icon: '☁', used: 42, total: '5 TB', color: 'var(--color-ocean-500)' },
  { id: 'backup', label: 'Backups', icon: '🗄', used: 28, total: '2 TB', color: 'var(--color-success)' },
];

const FILE_TREE = [
  { id: 1, name: 'Documents', type: 'folder', size: '2.4 GB', modified: 'Today', children: true },
  { id: 2, name: 'Projects', type: 'folder', size: '8.1 GB', modified: 'Yesterday', children: true },
  { id: 3, name: 'exports', type: 'folder', size: '340 MB', modified: 'Feb 20', children: true },
  { id: 4, name: 'dashboard-backup-2026.zip', type: 'zip', size: '142 MB', modified: 'Feb 18' },
  { id: 5, name: 'database-dump.sql', type: 'sql', size: '28 MB', modified: 'Feb 15' },
  { id: 6, name: 'invoice-template.pdf', type: 'pdf', size: '520 KB', modified: 'Feb 12' },
  { id: 7, name: 'logo-assets.svg', type: 'svg', size: '44 KB', modified: 'Feb 10' },
];

const FILE_ICONS: Record<string, string> = {
  folder: '📁', zip: '📦', sql: '🗄', pdf: '📄', svg: '🎨', default: '📋'
};

export default function FilesPage() {
  const [selectedDrive, setSelectedDrive] = useState('local');
  const [selected, setSelected] = useState<number | null>(null);
  const { addToast } = useToast();

  return (
    <div className="files-page">
      <PageHeader
        title="Files"
        breadcrumb={['Ops', 'Files']}
        actions={
          <>
            <Button variant="ghost" size="sm" icon="⬆" onClick={() => addToast('info', 'Upload dialog coming soon!')}>Upload</Button>
            <Button size="sm" icon="+" onClick={() => addToast('info', 'New folder created!')}>New Folder</Button>
          </>
        }
      />

      {/* Drive Cards */}
      <div className="files-drives">
        {DRIVES.map(d => (
          <button
            key={d.id}
            className={`drive-card${selectedDrive === d.id ? ' drive-card--active' : ''}`}
            onClick={() => setSelectedDrive(d.id)}
          >
            <div className="drive-card__header">
              <span className="drive-card__icon">{d.icon}</span>
              <span className="drive-card__label">{d.label}</span>
            </div>
            <div className="drive-card__bar-bg">
              <div className="drive-card__bar-fill" style={{ width: `${d.used}%`, background: d.color }} />
            </div>
            <div className="drive-card__meta">
              <span style={{ color: d.color, fontWeight: 700 }}>{d.used}% used</span>
              <span style={{ color: 'var(--color-muted)' }}>{d.total}</span>
            </div>
          </button>
        ))}
      </div>

      {/* File Browser */}
      <div className="files-browser">
        <div className="files-toolbar">
          <div className="files-breadcrumb">
            <button className="files-bc-item">Root</button>
            <span className="files-bc-sep">›</span>
            <button className="files-bc-item files-bc-item--active">
              {DRIVES.find(d => d.id === selectedDrive)?.label}
            </button>
          </div>
          <div className="files-toolbar-right">
            <input className="files-search" placeholder="Search files…" />
          </div>
        </div>
        <div className="files-table-wrap">
          <table className="files-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Size</th>
                <th>Modified</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {FILE_TREE.map(f => (
                <tr
                  key={f.id}
                  className={selected === f.id ? 'files-row--selected' : ''}
                  onClick={() => setSelected(f.id)}
                >
                  <td>
                    <div className="files-name-cell">
                      <span className="files-icon">{FILE_ICONS[f.type] || FILE_ICONS.default}</span>
                      <span className="files-name">{f.name}</span>
                      {f.children && <span className="files-children-indicator">›</span>}
                    </div>
                  </td>
                  <td><Badge variant={f.type === 'folder' ? 'default' : f.type === 'pdf' ? 'danger' : f.type === 'sql' ? 'ocean' : 'purple'}>{f.type.toUpperCase()}</Badge></td>
                  <td className="files-muted">{f.size}</td>
                  <td className="files-muted">{f.modified}</td>
                  <td>
                    <div className="files-actions">
                      <button className="asset-btn" title="Download" onClick={e => { e.stopPropagation(); addToast('success', `Downloading ${f.name}`); }}>⬇</button>
                      <button className="asset-btn" title="Rename" onClick={e => e.stopPropagation()}>✏</button>
                      <button className="asset-btn asset-btn--danger" title="Delete" onClick={e => e.stopPropagation()}>🗑</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
